export interface ImageFilters {
  brightness: number;
  contrast: number;
  grayscale: number;
  invert: number;
  opacity: number;
  saturate: number;
  sepia: number;
  blur: number;
  hue: number;
  rotate: number;
  scaleX: number;
  scaleY: number;
  borderRadius: number;
  top: number;
  left: number;
  right: number;
  bottom: number;
  clipPath: boolean;
}

export const DEFAULT_FILTERS: ImageFilters = {
  brightness: 100,
  contrast: 100,
  grayscale: 0,
  invert: 0,
  opacity: 100,
  saturate: 100,
  sepia: 0,
  blur: 0,
  hue: 0,
  rotate: 0,
  scaleX: 1,
  scaleY: 1,
  borderRadius: 0,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  clipPath: false
};
